import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { delete_hygiene_task_status } from "../../../data/ApiEndpoints";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import Loader from "../../ui/Loader";
import { formatDateTimezon } from "../../common-data/Converts";
import {
  BinIcon,
  CheckCircleIcon,
  EditIcon,
  EditIcon1,
  XCircleIcon,
} from "../../../images/icons/icons";

const HygieneCategoryListings = ({
  userInfoData,
  setModValues,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { loading: delApiLoading } = useSelector((state) => state.delApi);
  const {
    hygieneCategoriesLoading,
    hygieneCategories,
    error,
    // hygineTaskCategory,
    // hygineTaskCategoryLoading,
    // hygineTaskCategoryError,
  } = useSelector((state) => state.hygiene);

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: delete_hygiene_task_status,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    if (
      !hygieneCategoriesLoading &&
      !error &&
      hygieneCategories?.status &&
      hygieneCategories?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: hygieneCategories.data,
        pagination:
          hygieneCategories?.pagination?.length > 0
            ? hygieneCategories.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [hygieneCategoriesLoading, error, hygieneCategories]);

  const tbColumns = [
    {
      dataField: "name",
      text: "status name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "color_hex",
      text: "color",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth90"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "50px",
                height: "35px",
                borderRadius: "10px",
                background: row?.color_hex || "",
              }}
            ></div>
          </span>
        );
      },
    },
    {
      dataField: "add_gym_req",
      text: "create ticket",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.add_gym_req ? <CheckCircleIcon /> : <XCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth100 withPadding borderRdius8"
            style={{
              background: row?.status === "active" ? "#379C00" : "#C80000",
              color: "#fff",
            }}
          >
            {row?.status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "created on",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="hygiene-action-btn-container">
          <button
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "edit",
              }))
            }
          >
            <EditIcon />
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter);
            }}
          >
            {delApiLoading ? <Loader /> : <BinIcon />}
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="hygiene-tb-container mt30">
      {hygieneCategoriesLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <PaymentLinkTable
          tableData={allDatas.allData}
          tableColumns={tbColumns}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default HygieneCategoryListings;
